import PersonDisplay, { VerticalPersonDisplay } from './person-display';

export { VerticalPersonDisplay };
export default PersonDisplay;
